import axios from "axios";

//TODO: Comment during production
// Set up the API URL from .env, with a default fallback
const apiUrl = process.env.REACT_APP_API_URL;
// const apiUrl = "http://localhost:5000/";

// Create axios instance with base settings
const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true, // Send cookies for token handling
});

// Request interceptor to attach access token if available
apiClient.interceptors.request.use(
  (config) => {
    const accessToken =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors (token expiration)
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check for 401 Unauthorized and retry with new access token if available
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshResponse = await apiClient.post("/auth/refresh");
        const newAccessToken = refreshResponse.data.accessToken;

        // Store the new access token
        localStorage.setItem("accessToken", newAccessToken);

        // Retry the original request with the updated token
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);
        // Clear tokens and redirect if refresh fails (optional)
        localStorage.removeItem("accessToken");
        sessionStorage.removeItem("accessToken");
        window.location.href = "/login"; // Redirect to login on failure
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
